import { useCallback, useEffect, useRef, useState } from 'react';
import { effortPrefKey, readEffortPref, writeEffortPref } from '../utils/effortPreference.js';

// Repli commun quand localStorage est bloqué : la préférence vaut pour la session
const memory = new Map();

function localStorageOf() {
  try {
    return window.localStorage ?? null;
  } catch {
    // La simple lecture de la propriété lève si le navigateur bloque le stockage
    return null;
  }
}

/**
 * Niveau d'effort choisi dans le compositeur, mémorisé par utilisateur
 * (clé digitrans_effort:<entreprise_id>:<user_id>, jamais le hash).
 * @returns {{effort: string, setEffort: (level: string) => void}}
 */
export function useEffortPreference(userContext) {
  const key = effortPrefKey(userContext);
  const [effort, setState] = useState(() => readEffortPref(localStorageOf(), key, memory));
  const keyRef = useRef(key);

  // Autre utilisateur dans le même onglet : sa propre préférence
  useEffect(() => {
    if (keyRef.current === key) return;
    keyRef.current = key;
    setState(readEffortPref(localStorageOf(), key, memory));
  }, [key]);

  const setEffort = useCallback((level) => {
    setState(writeEffortPref(localStorageOf(), keyRef.current, level, memory));
  }, []);

  return { effort, setEffort };
}
